module.exports = __webpack_public_path__ + "img/f4.bb58ce40.jpg";